module.exports = __webpack_public_path__ + "img/95bd01da3e68d1932e085c9534c5f343.svg";